import { forwardRef } from 'react'

import type { SelectInputProps } from '@/types/components/select-input'
import { Icon } from '@components/Icon'

import './select-input.scss'
import clsx from 'clsx'

export const SelectInput = forwardRef<HTMLSelectElement, SelectInputProps>(
  (
    {
      label,
      required,
      name,
      placeholder,
      values,
      disabled,
      alpineErrorValue,
      className,
      ...selectProps
    },
    ref,
  ) => {
    const classes = `form-input ${disabled ? 'form-input--disabled' : ''} ${
      alpineErrorValue ? 'form-input--error' : ''
    }`

    return (
      <label className={classes}>
        <span className="type-label">{label}</span>
        {required && <span className="form-input__required type-label">*</span>}
        <div className="form-input__select-wrapper">
          <select
            className={clsx('form-input__select', className)}
            name={name}
            required={required}
            disabled={disabled}
            ref={ref}
            {...selectProps}
          >
            {placeholder && (
              <option value="" selected disabled hidden>
                {placeholder}
              </option>
            )}
            {values?.length > 0 &&
              values.map((value, index) => (
                <option key={index} value={value}>
                  {value}
                </option>
              ))}
          </select>
          <span className="form-input__select-arrow">
            <Icon name="select-arrow" />
          </span>
        </div>
        {alpineErrorValue && (
          <div className="error">
            <div className="error__message">
              <span className="error__icon">
                <Icon name="attention" />
              </span>
              <span>{alpineErrorValue}</span>
            </div>
          </div>
        )}
      </label>
    )
  },
)

SelectInput.displayName = 'SelectInput'
